export default (function () {
  return {
    width: undefined,
    height: undefined
  };
});